import { render, staticRenderFns } from "./ListagemFornecedores.vue?vue&type=template&id=4c45a35c&"
import script from "./ListagemFornecedores.vue?vue&type=script&lang=js&"
export * from "./ListagemFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./ListagemFornecedores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports